module.exports = __webpack_public_path__ + "img/param.00961208.png";